import React from 'react';
import { useCMS } from '../contexts/CMSContext';
import { useI18n } from '../i18n';
import './Hero.css';

const Hero: React.FC = () => {
  const { data } = useCMS();
  const { t } = useI18n();

  const heroDesc = data?.hero?.title_en || t('hero.desc');

  return (
    <section id="hero" className="hero">
      {/* poster shows instantly, video replaces it once loaded */}
      <video
        className="hero-video"
        autoPlay
        loop
        muted
        playsInline
        poster="/portrait.jpg"
        preload="auto"
      >
        <source src="/1.webm" type="video/webm" />
      </video>
      <div className="hero-overlay" />

      <div className="hero-content">
        <p className="hero-eyebrow">{t('hero.eyebrow')}</p>

        <h1 className="hero-name">
          ANDRXW
          <svg className="hero-sigil" viewBox="0 0 60 60" width="48" height="48">
            <ellipse cx="30" cy="30" rx="28" ry="10" fill="none" stroke="white" strokeWidth="1" transform="rotate(-30 30 30)" opacity="0.6"/>
            <path d="M30 10 L32 28 L50 30 L32 32 L30 50 L28 32 L10 30 L28 28 Z" fill="white" opacity="0.9"/>
          </svg>
        </h1>

        <div className="hero-sub">
          <p className="hero-desc" dangerouslySetInnerHTML={{
            __html: heroDesc.replace(/\n/g, '<br/>')
          }} />
          <div className="hero-coords">
            <span>LAT 44.4268° N</span>
            <span>LON 26.1025° E</span>
            <span className="hero-scroll">{t('hero.scroll')}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
